/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {useQuery} from '@tanstack/react-query'

import {getTemplates, getTemplatesByContractType, getTemplate} from './api'
import {TemplateResponseData} from './api'
import {templateKeys} from './keys'

export const useTemplatesByCompany = (companyId?: string) => {
  return useQuery<TemplateResponseData[], unknown>({
    queryKey: templateKeys.listByCompany(companyId || ''),
    queryFn: () => getTemplates(companyId!),
    enabled: !!companyId,
  })
}

export const useTemplatesByContractType = (contractTypeId?: string) => {
  return useQuery<TemplateResponseData[], unknown>({
    queryKey: templateKeys.listByContractType(contractTypeId || ''),
    queryFn: () => getTemplatesByContractType(contractTypeId!),
    enabled: !!contractTypeId,
  })
}

export const useTemplate = (id?: string) => {
  return useQuery<TemplateResponseData, unknown>({
    queryKey: templateKeys.detail(id || ''),
    queryFn: () => getTemplate(id!),
    enabled: !!id,
  })
}
